import { AxIconWrapper, AxInput } from "@dynata/axiom3";
import { ChangeEvent, ReactNode, useCallback, useState } from "react";
import "./editable-text.scss";

interface InputProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onPressEnter?: () => Promise<void>;
  onBlur?: () => Promise<void>;
  placeholder?: string;
  autoFocus?: boolean;
  value: string;
  type?: string;
  size?: string;
}

interface IEditableTextProps extends InputProps {
  children: ReactNode;
  icon?: string;
}

export function EditableText({
  icon = "fa-pen",
  children,
  ...rest
}: IEditableTextProps) {
  const [isHovering, setIsHovering] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const onBlur = useCallback(async () => {
    if (!rest.onBlur) return;

    setIsEditing(false);
    await rest.onBlur();
  }, [rest.onBlur]);

  const onPressEnter = useCallback(async () => {
    if (!rest.onPressEnter) return;

    setIsEditing(false);
    await rest.onPressEnter();
  }, [rest.onPressEnter]);

  const onClick = () => {
    setIsHovering(false);
    setIsEditing(true);
  };

  return isEditing ? (
    <AxInput
      {...rest}
      onBlur={onBlur}
      onPressEnter={onPressEnter}
    />
  ) : (
    <div
      className="editable-text"
      onClick={onClick}
      onMouseOver={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {children}
      <div
        aria-hidden={!isHovering}
        className="editable-icon"
      >
        <AxIconWrapper icon={icon} />
      </div>
    </div>
  );
}
